module.exports = __webpack_public_path__ + "static/media/icono-abrir.ed7c34f7.png";